import type { ReactNode } from 'react';

import { WorkspaceSkeleton } from '@/app/layouts';
import { LoginShell } from '@/pages/login/LoginShell';
import { UnsupportedMobilePage } from '@/pages/unsupported-mobile/UnsupportedMobilePage';
import { isMobileBrowser } from '@/shared/lib/device/isMobileDevice';

import { useClinicianOnboardingOrchestrator } from '../model/useClinicianOnboardingOrchestrator';
import { ClinicianOnboardingWizard } from './ClinicianOnboardingWizard';

interface ClinicianOnboardingGateProps {
  children: ReactNode;
}

export function ClinicianOnboardingGate({ children }: ClinicianOnboardingGateProps) {
  const orchestrator = useClinicianOnboardingOrchestrator();

  if (orchestrator.step.kind === 'loading') {
    return <WorkspaceSkeleton />;
  }

  if (orchestrator.step.kind === 'complete') {
    return isMobileBrowser() ? <UnsupportedMobilePage /> : children;
  }

  return (
    <LoginShell contentClassName="items-stretch justify-start">
      <div className="flex h-full w-full min-h-0 flex-1">
        <ClinicianOnboardingWizard orchestrator={orchestrator} />
      </div>
    </LoginShell>
  );
}
